/*
 * @Author: your name
 * @Date: 2022-01-06 17:06:06
 * @LastEditTime: 2022-01-12 10:52:55
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\utils\servers.ts
 */
import { COMMON, QYWX_URL } from "../const"
import request from "./request"
export * from "../services/group"
export * from "../services/customer"
export * from "../services/material"
export * from "../services/product"
export * from "../services/communicate"
export * from "../services/sourceMaterial"
export * from "../services/customerJorney"
export * from "../services/scriptLibrary"
export * from "../services/audit"

const loginApp = () => request.get(`${COMMON.loginApp}`)
const initConfig = (options: any = {}) => {
  return request.get(`${QYWX_URL.queryJsSignature}`, { params: options })
}

const getExternalContact = (wxUserId: number | string) => {
  return request.get(
    `${QYWX_URL.getExternalContact}?externalUserId=${wxUserId}`,
  )
}
const getRecordList = (url: string, params: any) => request.get(url, { params })

const uploadFile = (params: any) => {
  return request.post(COMMON.upload, {
    requestType: "form",
    data: params,
  })
}

const saveUserDetail = (url: string, params: any) => {
  return request.post(url, { data: params })
}

export {
  loginApp,
  initConfig,
  uploadFile,
  getExternalContact,
  getRecordList,
  saveUserDetail,
}
